// extracted by mini-css-extract-plugin
export default {"tabContainer":"_tab_tabContainer__JEajG","header":"_tab_header__V33+h","tab":"_tab_tab__vTY7M","active":"_tab_active__SnqsL","slider":"_tab_slider__HOXGs"};